require('angular-animate');

// TODO: WIP...

var animations = angular.module('animations', ['ngAnimate']);

var animationDuration = 500;

function findChildWithClass(start_element, class_to_find) {
    while (start_element && (start_element.classList + ' ').indexOf(class_to_find + ' ') < 0) {
        if (!start_element.children.length) {
            return null;
        }
        start_element = start_element.children[0];
    }
    return start_element;
}

animations.animation('.animate-group', ['$animateCss', function ($animateCss) {
    return {
        enter: function (element) {
            return $animateCss(element, {
                from: {opacity: '0'},
                to: {opacity: '1'},
                duration: animationDuration / 1000
            });
        },
        leave: function (element) {
            return $animateCss(element, {
                from: {opacity: '1'},
                to: {opacity: '0'},
                duration: animationDuration / 1000
            });
        }
    };
}]);

animations.animation('.animate-section', ['$animateCss', function ($animateCss) {
    return {
        enter: function (element) {
            setTimeout(function () {
                element[0].style.overflow = '';
                element[0].style.height = '';
                element[0].style.opacity = '';
            }, animationDuration + 50);
            element[0].style.overflow = 'hidden';
            return $animateCss(element, {
                from: {opacity: '0', height: '0px'},
                to: {opacity: '1', height: element[0].getBoundingClientRect().height + 'px'},
                duration: animationDuration / 1000
            });
        },
        leave: function (element/*, done*/) {
            element[0].style.overflow = 'hidden';
            return $animateCss(element, {
                from: {opacity: '1', height: element[0].getBoundingClientRect().height + 'px'},
                to: {opacity: '0', height: '0px'},
                duration: animationDuration / 1000
            });
        }
    };
}]);

animations.animation('.animate-slot-class', [function () {
    return {
        enter: function (element, done) {
            var el = findChildWithClass(element[0], 'slot');
            if (!el) return;
            var width = el.offsetWidth, height = el.offsetHeight;

            el.style.maxHeight = height + 'px';
            el.style.width = '0px';
            el.style.padding = '0px';
            el.style.overflow = 'hidden';
            el.style.transitionDuration = '0s';
            el.getBoundingClientRect();

            el.style.transitionDuration = (animationDuration / 1000) + 's';
            el.style.width = width * 0.8 + 'px';

            setTimeout(function () {
                el.style.width = '';
                // el.style.height = '';
                el.style.overflow = '';
                el.style.maxHeight = '';
                el.style.padding = '';
                el.style.transitionDuration = '';
                done();
            }, animationDuration);

        },
        leave: function (element, done) {
            var el = findChildWithClass(element[0], 'slot');
            var width = el.offsetWidth, height = el.offsetHeight;
            var oldWidth = width;
            el.style.height = height + 'px';
            el.style.width = width + 'px';
            el.style.overflow = 'hidden';
            el.style.padding = '0px';
            el.style.transitionDuration = '0s';
            el.style.maxHeight = height + 'px';
            //el.offsetWidth = el.offsetWidth;
            el.getBoundingClientRect();
            //setTimeout(function () {
            //el.style.transitionDuration = animationDuration2 + 's';
            //el.style.width = '0px';
            el.style.transitionDuration = '0.0s';
            // el.style.height= '';

            var context = el.parentElement.parentElement.parentElement;
            var lastWidth = width;
            var initial = true;
            var call = function () {
                var width = context.offsetWidth - 20;
                for (var i = 0; i < context.children.length; i++) {
                    var sub = context.children[i];
                    if (sub.children.length) {
                        sub = sub.children[0];
                    }
                    if (sub.children.length) {
                        sub = sub.children[0];
                    }
                    if (sub != el) {
                        width -= sub.offsetWidth;
                    }

                }

                if (initial && width < 0) {
                    el.style.transitionDuration = (animationDuration / 1000) + 's';
                    el.style.width = '0px';
                    return;
                }

                lastWidth -= (context.offsetWidth / 200) + 1;
                if (width > lastWidth) {

                    width = lastWidth;
                }
                initial = false;
                el.style.width = width + 'px';
                el.style.height = height * (width / oldWidth) + 'px';
                if (width > 0) {
                    setTimeout(call, 1);
                } else {
                    el.style.display = 'none';
                }
            };
            call();
            setTimeout(done, animationDuration);
        }
    };
}]);
